module.exports = __webpack_public_path__ + "img/destaques-da-obra.62190c6e.png";